import * as validationRules from '../validationRules';

export const validateIsCreditCard = (cardNumber: string) => {
  const { msg, validate } = validationRules.isCreditCard;

  if (!validate(cardNumber)) {
    return msg;
  }

  return null;
};
